import { render } from "./PayoffCompany.vue?vue&type=template&id=7754d777"
import script from "./PayoffCompany.vue?vue&type=script&lang=js"
export * from "./PayoffCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__